import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import _ from 'lodash';
import { getGenericModal } from '../../../redux/selectors/ui';
import { ModalDocumentAction } from '../../../redux/actions/modal';
import { PreviewObject } from '../../../models/files';
import { canBePreviewed } from '../../../utils/functions';

export interface PreviewProps extends RouteComponentProps {
    previewObject?: PreviewObject
}
class Preview extends React.Component<PreviewProps> {
    constructor(props: PreviewProps) {
        super(props);   
    }


    render(){
        const { previewObject } = this.props;
        const isAllowedPreview = !!previewObject && canBePreviewed(previewObject.ext);
        return (
            <>  
                {previewObject && 
                    <> 
                        <div style={{width: '100%', height: 'calc(100vh - 300px)'}}>
                            {!isAllowedPreview &&
                                <p>Preview not available for this file type.</p>
                            }
                            {isAllowedPreview && previewObject.ext !== 'pdf' && previewObject.ext !== 'PDF' &&
                                <img src={previewObject.url} alt="File preview" style={{maxWidth: '100%', maxHeight: '100%', objectFit: 'contain'}} />
                            }
                            {isAllowedPreview && (previewObject.ext === 'pdf' || previewObject.ext === 'PDF') &&
                                <iframe src={previewObject.url} title="PDF preview" width="100%" height="100%" style={{border: 0}}>
                                    <p>Alternative text - include a link <a href={previewObject.url}>to the PDF!</a></p>
                                </iframe>                      
                            }
                        </div>        
                    </>
                }     
            </>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    previewObject: (state) => (getGenericModal('preview')(state)) ? (getGenericModal('preview')(state) as any).contextItem as PreviewObject : undefined,
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        setContextItem: ModalDocumentAction.setContextItem,
        setContextItemProperty: ModalDocumentAction.setContextItemProperty
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)(withRouter(Preview));